// extracted by css-extract-rspack-plugin
export default {"accordionList":"yjbk6"};